export type EmojiCategory = {
    name: string
    icon: string
    emojis: string[]
}

export const emojiCategories: EmojiCategory[] = [
    {
        name: '笑脸',
        icon: '😀',
        emojis: [
            '😀', '😃', '😄', '😁', '😆', '😅', '🤣', '😂', '🙂', '🙃',
            '😉', '😊', '😇', '🥰', '😍', '🤩', '😘', '😗', '☺', '😚',
            '😙', '🥲', '😋', '😛', '😜', '🤪', '😝', '🤑', '🤗', '🤭',
            '🤫', '🤔', '🫡', '🤐', '🤨', '😐', '😑', '😶', '🫥', '😏',
            '😒', '🙄', '😬', '🤥', '🫨', '😌', '😔', '😪', '🤤', '😴',
            '😷', '🤒', '🤕', '🤢', '🤮', '🥵', '🥶', '🥴', '😵', '🤯',
            '🤠', '🥳', '🥸', '😎', '🤓', '🧐', '😕', '🫤', '😟', '🙁',
            '☹', '😮', '😯', '😲', '😳', '🥺', '🥹', '😦', '😧', '😨',
            '😰', '😥', '😢', '😭', '😱', '😖', '😣', '😞', '😓', '😩',
            '😫', '🥱', '😤', '😡', '😠', '🤬', '😈', '👿', '💀', '☠',
            '💩', '🤡', '👹', '👺', '👻', '👽', '👾', '🤖',
        ],
    },
    {
        name: '手势',
        icon: '👋',
        emojis: [
            '👋', '🤚', '🖐', '✋', '🖖', '🫱', '🫲', '🫳', '🫴', '👌',
            '🤌', '🤏', '✌', '🤞', '🫰', '🤟', '🤘', '🤙', '👈', '👉',
            '👆', '🖕', '👇', '☝', '🫵', '👍', '👎', '✊', '👊', '🤛',
            '🤜', '👏', '🙌', '🫶', '👐', '🤲', '🤝', '🙏', '💪', '🦾',
            '🦿', '🦵', '🦶', '👂', '🦻', '👃', '🧠', '🫀', '🫁', '🦷',
            '🦴', '👀', '👁', '👅', '👄', '🫦',
        ],
    },
    {
        name: '人物',
        icon: '👤',
        emojis: [
            '👶', '🧒', '👦', '👧', '🧑', '👱', '👨', '🧔', '👩', '🧓',
            '👴', '👵', '🙍', '🙎', '🙅', '🙆', '💁', '🙋', '🧏', '🙇',
            '🤦', '🤷', '👮', '🕵', '💂', '🥷', '👷', '🫅', '🤴', '👸',
            '👳', '👲', '🧕', '🤵', '👰', '🤰', '🫃', '🫄', '🤱', '👼',
            '🎅', '🤶', '🦸', '🦹', '🧙', '🧚', '🧛', '🧜', '🧝', '🧞',
            '🧟', '🧌', '💆', '💇', '🚶', '🧍', '🧎', '🏃', '💃', '🕺',
            '👯', '🧖', '🧗', '🤸', '⛹', '🏋', '🏌', '🏇', '🧘', '🛀',
            '🛌',
        ],
    },
    {
        name: '动物',
        icon: '🐶',
        emojis: [
            '🐶', '🐱', '🐭', '🐹', '🐰', '🦊', '🐻', '🐼', '🐻‍❄️', '🐨',
            '🐯', '🦁', '🐮', '🐷', '🐸', '🐵', '🙈', '🙉', '🙊', '🐒',
            '🐔', '🐧', '🐦', '🐤', '🐣', '🐥', '🦆', '🦅', '🦉', '🦇',
            '🐺', '🐗', '🐴', '🦄', '🐝', '🪱', '🐛', '🦋', '🐌', '🐞',
            '🐜', '🪰', '🪲', '🪳', '🦟', '🦗', '🕷', '🦂', '🐢', '🐍',
            '🦎', '🐙', '🦑', '🦐', '🦞', '🦀', '🐡', '🐠', '🐟', '🐬',
            '🐳', '🐋', '🦈', '🦭', '🐊', '🐅', '🐆', '🦓', '🦍', '🦧',
            '🐘', '🦛', '🦏', '🐪', '🐫', '🦒', '🦘', '🦬', '🐃', '🐂',
            '🐄', '🐎', '🐖', '🐏', '🐑', '🦙', '🐐', '🦌', '🐕', '🐩',
            '🦮', '🐕‍🦺', '🐈', '🐈‍⬛', '🪶', '🐓', '🦃', '🦤', '🦚', '🦜',
            '🦢', '🦩', '🕊', '🐇', '🦝', '🦨', '🦡', '🦫', '🦦', '🦥',
            '🐁', '🐀', '🐿', '🦔', '🐾',
        ],
    },
    {
        name: '自然',
        icon: '🌸',
        emojis: [
            '🌵', '🎄', '🌲', '🌳', '🌴', '🪵', '🌱', '🌿', '☘', '🍀',
            '🎍', '🪴', '🎋', '🍃', '🍂', '🍁', '🪺', '🪹', '🍄', '🐚',
            '🪸', '🪨', '🌾', '💐', '🌷', '🌹', '🥀', '🌺', '🌸', '🌼',
            '🌻', '🌞', '🌝', '🌛', '🌜', '🌚', '🌕', '🌖', '🌗', '🌘',
            '🌑', '🌒', '🌓', '🌔', '🌙', '🌎', '🌍', '🌏', '🪐', '💫',
            '⭐', '🌟', '✨', '⚡', '☄', '🔥', '🌪', '🌈', '☀', '🌤',
            '⛅', '🌥', '☁', '🌦', '🌧', '⛈', '🌩', '🌨', '❄', '☃',
            '⛄', '🌬', '💨', '💧', '💦', '🫧', '☔', '☂', '🌊', '🌫',
        ],
    },
    {
        name: '饮食',
        icon: '🍎',
        emojis: [
            '🍏', '🍎', '🍐', '🍊', '🍋', '🍌', '🍉', '🍇', '🍓', '🫐',
            '🍈', '🍒', '🍑', '🥭', '🍍', '🥥', '🥝', '🍅', '🍆', '🥑',
            '🥦', '🥬', '🥒', '🌶', '🫑', '🌽', '🥕', '🫒', '🧄', '🧅',
            '🥔', '🍠', '🫘', '🥐', '🍞', '🥖', '🥨', '🧀', '🥚', '🍳',
            '🧈', '🥞', '🧇', '🥓', '🥩', '🍗', '🍖', '🌭', '🍔', '🍟',
            '🍕', '🫓', '🥪', '🥙', '🧆', '🌮', '🌯', '🫔', '🥗', '🥘',
            '🫕', '🥫', '🍝', '🍜', '🍲', '🍛', '🍣', '🍱', '🥟', '🦪',
            '🍤', '🍙', '🍚', '🍘', '🍥', '🥠', '🥮', '🍢', '🍡', '🍧',
            '🍨', '🍦', '🥧', '🧁', '🍰', '🎂', '🍮', '🍭', '🍬', '🍫',
            '🍿', '🍩', '🍪', '🌰', '🥜', '🍯', '🥛', '🍼', '🫖', '☕',
            '🍵', '🧃', '🥤', '🧋', '🍶', '🍺', '🍻', '🥂', '🍷', '🥃',
            '🍸', '🍹', '🧉', '🍾', '🧊',
        ],
    },
    {
        name: '活动',
        icon: '⚽',
        emojis: [
            '🎃', '🎄', '🎆', '🎇', '🧨', '✨', '🎈', '🎉', '🎊', '🎋',
            '🎍', '🎎', '🎏', '🎐', '🎑', '🧧', '🎀', '🎁', '🎗', '🎟',
            '🎫', '🎖', '🏆', '🏅', '🥇', '🥈', '🥉', '⚽', '⚾', '🥎',
            '🏀', '🏐', '🏈', '🏉', '🎾', '🥏', '🎳', '🏏', '🏑', '🏒',
            '🥍', '🏓', '🏸', '🥊', '🥋', '🥅', '⛳', '⛸', '🎣', '🤿',
            '🎽', '🎿', '🛷', '🥌', '🎯', '🪀', '🪁', '🎱', '🔮', '🪄',
            '🧿', '🪬', '🎮', '🕹', '🎰', '🎲', '🧩', '🧸', '🪅', '🪆',
            '♠', '♥', '♦', '♣', '♟', '🃏', '🀄', '🎴', '🎭', '🖼',
            '🎨', '🧵', '🪡', '🧶', '🪢',
        ],
    },
    {
        name: '旅行',
        icon: '✈',
        emojis: [
            '🚗', '🚕', '🚙', '🚌', '🚎', '🏎', '🚓', '🚑', '🚒', '🚐',
            '🛻', '🚚', '🚛', '🚜', '🛵', '🏍', '🛺', '🚲', '🛴', '🛹',
            '🛼', '🚁', '✈', '🛩', '🛫', '🛬', '🪂', '💺', '🚀', '🛸',
            '🚢', '⛵', '🛶', '🚤', '🛥', '🛳', '⛴', '🗼', '🗽', '🗿',
            '🏰', '🏯', '🏟', '🎡', '🎢', '🎠', '⛲', '⛱', '🏖', '🏝',
            '🏜', '🌋', '⛰', '🏔', '🗻', '🏕', '⛺', '🏠', '🏡', '🏘',
            '🏚', '🏗', '🏭', '🏢', '🏬', '🏣', '🏤', '🏥', '🏦', '🏨',
            '🏪', '🏫', '🏩', '💒', '🏛', '⛪', '🕌', '🕍', '🛕', '🕋',
            '⛩', '🗾', '🌏', '🌍', '🌎', '🧭', '🏔', '🌋', '🗻', '🏕',
        ],
    },
    {
        name: '物品',
        icon: '💡',
        emojis: [
            '⌚', '📱', '📲', '💻', '⌨', '🖥', '🖨', '🖱', '🖲', '🕹',
            '🗜', '💽', '💾', '💿', '📀', '📼', '📷', '📸', '📹', '🎥',
            '📽', '🎞', '📞', '☎', '📟', '📠', '📺', '📻', '🎙', '🎚',
            '🎛', '🧭', '⏱', '⏲', '⏰', '🕰', '⌛', '⏳', '📡', '🔋',
            '🪫', '🔌', '💡', '🔦', '🕯', '🪔', '🧯', '🛢', '💰', '🪙',
            '💴', '💵', '💶', '💷', '🪪', '💳', '💎', '⚖', '🪜', '🧰',
            '🪛', '🔧', '🔨', '⚒', '🛠', '⛏', '🪚', '🔩', '⚙', '🪤',
            '🧱', '⛓', '🧲', '🔫', '💣', '🧨', '🪓', '🔪', '🗡', '⚔',
            '🛡', '🚬', '⚰', '🪦', '⚱', '🏺', '🔮', '📿', '🧿', '🪬',
            '💈', '⚗', '🔭', '🔬', '🕳', '🩹', '🩺', '🩻', '🩼', '💊',
            '💉', '🩸', '🧬', '🦠', '🧫', '🧪', '🌡', '🧹', '🪠', '🧺',
            '🧻', '🚽', '🪣', '🧼', '🪥', '🧽', '🧴', '🔑', '🗝', '🚪',
            '🪑', '🛋', '🛏', '🪞', '🪟', '🧳',
        ],
    },
    {
        name: '符号',
        icon: '❤',
        emojis: [
            '❤', '🧡', '💛', '💚', '💙', '💜', '🖤', '🤍', '🤎', '💔',
            '❣', '💕', '💞', '💓', '💗', '💖', '💘', '💝', '💟', '☮',
            '✝', '☪', '🕉', '☸', '✡', '🔯', '🕎', '☯', '☦', '🛐',
            '⛎', '♈', '♉', '♊', '♋', '♌', '♍', '♎', '♏', '♐',
            '♑', '♒', '♓', '🆔', '⚛', '🉑', '☢', '☣', '📴', '📳',
            '🈶', '🈚', '🈸', '🈺', '🈷', '✴', '🆚', '💮', '🉐', '㊙',
            '㊗', '🈴', '🈵', '🈹', '🈲', '🅰', '🅱', '🆎', '🆑', '🅾',
            '🆘', '❌', '⭕', '🛑', '⛔', '📛', '🚫', '💯', '💢', '♨',
            '🚷', '🚯', '🚳', '🚱', '🔞', '📵', '🚭', '❗', '❕', '❓',
            '❔', '‼', '⁉', '🔅', '🔆', '〽', '⚠', '🚸', '🔱', '⚜',
            '🔰', '♻', '✅', '🈯', '💹', '❇', '✳', '❎', '🌐', '💠',
            'Ⓜ', '🌀', '💤', '🏧', '🚾', '♿', '🅿', '🛗', '🈳', '🈂',
            '🛂', '🛃', '🛄', '🛅', '🚹', '🚺', '🚼', '⚧', '🚻', '🚮',
            '🎦', '📶', '🈁', '🔣', 'ℹ', '🔤', '🔡', '🔠', '🆖', '🆗',
            '🆙', '🆒', '🆕', '🆓', '0️⃣', '1️⃣', '2️⃣', '3️⃣', '4️⃣', '5️⃣',
            '6️⃣', '7️⃣', '8️⃣', '9️⃣', '🔟', '🔢', '#️⃣', '*️⃣', '⏏', '▶',
            '⏸', '⏯', '⏹', '⏺', '⏭', '⏮', '⏩', '⏪', '⏫', '⏬',
            '◀', '🔼', '🔽', '➡', '⬅', '⬆', '⬇', '↗', '↘', '↙',
            '↖', '↕', '↔', '↪', '↩', '⤴', '⤵', '🔀', '🔁', '🔂',
            '🔄', '🔃', '🎵', '🎶', '➕', '➖', '➗', '✖', '🟰', '♾',
            '💲', '💱', '™', '©', '®', '〰', '➰', '➿', '🔚', '🔙',
            '🔛', '🔝', '🔜', '✔', '☑', '🔘', '🔴', '🟠', '🟡', '🟢',
            '🔵', '🟣', '⚫', '⚪', '🟤', '🔺', '🔻', '🔸', '🔹', '🔶',
            '🔷', '🔳', '🔲', '▪', '▫', '◾', '◽', '◼', '◻', '🟥',
            '🟧', '🟨', '🟩', '🟦', '🟪', '⬛', '⬜', '🟫', '🔈', '🔇',
            '🔉', '🔊', '🔔', '🔕', '📣', '📢', '💬', '💭', '🗯', '♠',
            '♣', '♥', '♦', '🃏', '🎴', '🀄', '🕐', '🕑', '🕒', '🕓',
            '🕔', '🕕', '🕖', '🕗', '🕘', '🕙', '🕚', '🕛', '🕜', '🕝',
            '🕞', '🕟', '🕠', '🕡', '🕢', '🕣', '🕤', '🕥', '🕦', '🕧',
        ],
    },
]
